import React, {useEffect, useState} from "react";
import {BallTriangle} from 'react-loader-spinner'
import './style.css';
import { socket } from "../../socket";

const Conversation = ({conversation, currentUser, onClick, active }) => {
    const [isRead, setIsRead] = useState(false);
    const [typingUsers, setTypingUsers] = useState([]);

    // socket.current = io(process.env.REACT_APP_SOCKET_URL);

    useEffect(() => {
        //{ withCredentials: true, transports: ["websocket"] }
        const handleMessageCreated = (data) => {
            if (data?.chatId === conversation.id) {
                setIsRead(false);
            }
        };

        const handleUserTyping = ({chatId, userId, nickname, isTyping: typing}) => {
            if (Number(chatId) === Number(conversation.id) && Number(userId) !== Number(currentUser.id)) {
                setTypingUsers(prev => {
                    if (typing) {
                        // Add user to typing list if not already there
                        const existingUser = prev.find(user => user.userId === userId);
                        if (!existingUser) {
                            return [...prev, { userId, nickname }];
                        }
                        return prev;
                    } else {
                        // Remove user from typing list
                        return prev.filter(user => user.userId !== userId);
                    }
                });
            }
        };

        socket.on("messageCreated", handleMessageCreated);
        socket.on("userTyping", handleUserTyping);

        return () => {
            socket.off("messageCreated", handleMessageCreated);
            socket.off("userTyping", handleUserTyping);
        }
       
    }, [conversation.id, currentUser.id])

    useEffect(() => {
        if(active !== conversation.id){
            setIsRead(false);
            // Не скидаємо isTyping, щоб індикатор працював для всіх чатів
        }
    }, [active, conversation.id]);

    if (!conversation.sender) return <BallTriangle
        radius="1"
        color="white"
    />
    
    function getMainURL(main_url){
        const url = new URL(main_url);
        let originWithPathNameUrl = '';
        
        if(url?.pathname !== '/' || url?.pathname === undefined) 
        {
            originWithPathNameUrl = url.host + '/' + url.pathname.split("/")[1];
        }
        else{
            originWithPathNameUrl = url.host;
        }
    
        return originWithPathNameUrl;
    }

    const textForIcon = (nickname) => {
        if(!nickname) return "NF";

        if(nickname.length < 4) return nickname.toUpperCase();

        return nickname[0].toUpperCase();
    }

    return (
        <div onClick={() => { onClick(); setIsRead(true); }} className="cursor-pointer chat-item transition" style={{backgroundColor: active ===  conversation.id ? 'rgb(255 255 255 / 15%)' : ''}} >
            {conversation?.sender ? <>
                {/* <img className="rounded-circle contacts-image"
                src={imageBaseUrl} /> */}
                {(conversation?.newMsgCount && !isRead) ? <div className="badge-place-holder"><span className="badge badge-light badge-conversation">{conversation.newMsgCount}</span></div> : ''}
                <div className="d-flex info-chat" >
                    <div className="icon-text">{textForIcon(conversation.sender.nickname)}</div>
                    <div className="text-data">
                        <p style={{ fontSize: 'medium', padding: '0px 5px' }} className="text-white mb-0">{conversation.sender.nickname}</p>
                        {typingUsers.length > 0 ? (
                            <p className="mb-0 typing-text" style={{ padding: '0px 5px' }}>
                                {typingUsers.length === 1 
                                    ? `${typingUsers[0].nickname} набирає повідомлення...`
                                    : typingUsers.length === 2 
                                        ? `${typingUsers[0].nickname} і ${typingUsers[1].nickname} набирають повідомлення...`
                                        : `${typingUsers[0].nickname} і ${typingUsers[1].nickname} та ще ${typingUsers.length - 2} набирають повідомлення...`
                                }
                            </p>
                        ) : (
                            <>
                                {conversation.sender.titleCompany ?
                                    <p style={{ fontSize: '14px', padding: '0px 5px' }} className="text-white mb-0 title-company show-all">{conversation.sender.titleCompany}</p>
                                    :
                                    <p style={{ padding: '0px 5px' }} className="main-url text-white text-break show-all">
                                        {getMainURL(conversation.sender.main_url)}
                                    </p>
                                }
                            </>
                        )}
                    </div>
                </div>
            </> :
                <></>}
        </div>
    );
    
};
export default Conversation;